import * as actions from "@constants";

export const authReducer = (state, action) => {
  switch (action.type) {
    case actions.LOGGED_IN : {
        // add (user data + token access) + logged_in = true
        return {
            user_data: action.data,
            token_access: action.token_access,
            isLogged: true
        }
    }
    case actions.LOGGED_OUT : {
        // delete (user data + token access) + logged_in = false
        return {
            user_data: {},
            token_access: "",
            isLogged: false
        }
    }
    case actions.EDIT_USER : {
        // edit (user data)
        return {
          user_data: action.data,
          isLogged: true
        }
    }
    default: return state;
  }
} 